import { Component, OnInit } from '@angular/core';
import * as angular from 'angular';
import {downgradeComponent} from '@angular/upgrade/static';

@Component({
	selector: 'tt-notifications',
	templateUrl: './notifications.component.html',
	styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {

	constructor() { }

	ngOnInit(): void {
	}

}

angular.module('timetracker2')
	.directive(
		'ttMyTimeNotifications',
		downgradeComponent({ component: NotificationsComponent }) as angular.IDirectiveFactory
	);



// WEBPACK FOOTER //
// ./src/app/my-time/notifications/notifications.component.ts